import moment from 'moment-timezone';

import 'moment/locale/fr';

export default moment;
